export const CONTENT_WRAPPER_ID = 'pageLayoutWrapper';

export const PROGRESS_BAR_PARENT_ID = 'pageProgressBarParent';
